<ng-template #skeletonLoader let-count="$implicit">
  <ngx-skeleton-loader
    count="1"
    [animation]="animation"
    [theme]="{
      height: '16px',
      width: '150px',
      background:
        'linear-gradient(90deg, #9C9C9C 0%, #CECECE 18.23%, #F1F1F1 100%)',
      'animation-duration': '2s'
    }"
  >
  </ngx-skeleton-loader>
</ng-template>

<div class="orgApp-duties-loading-page-main-container">
  <div>
    <table
      mat-table
      [dataSource]="dataSource"
      class="orgApp-duties-loading-page-main-table"
    >
      <ng-container
        *ngFor="let column of columnsToDisplay; let i = index"
        [matColumnDef]="column"
      >
        <th mat-header-cell *matHeaderCellDef style="width: 20%"></th>
        <td mat-cell *matCellDef="let element" class="table-data">
          <span *ngIf="column !== 'more'">
            <ng-container *ngTemplateOutlet="skeletonLoader"></ng-container
          ></span>
          @if (column === 'more') {
          <span>
            <svg width="24" height="24">
              <use xlink:href="#dots-menu"></use>
            </svg>
          </span>
          }
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay"
        class="bg-color orgApp-header-row"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>
  </div>
</div>
